import { getAllUsers, myUsers, signUpUser, updatePortalUser, updateClient, createClient, putUserParents, postAssignClient } from '../api'
import { saveUser } from '../../services/authService'

// ---- Fetch Users ----
export const getUsers = async ({ commit, dispatch, getters }, { page, pageSize }) => {
  try {
    const res = await getAllUsers(page, pageSize)
    if (res && res instanceof Error) throw res
    commit('USERS', { data: res.data.results, total: res.data.total, page: res.data.page, pageSize: res.data.pageSize })
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const getMyUsers = async ({ commit, dispatch }, { page, pageSize }) => {
  try {
    const res = await myUsers(page, pageSize)
    if (res && res instanceof Error) throw res
    commit('USERS', { data: res.data.results, total: res.data.total, page: res.data.page, pageSize: res.data.pageSize })
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

// ---- Client ----
export const signUpPortalUser = async ({ commit, dispatch }, data) => {
  try {
    const res1 = await signUpUser(data)
    if (res1 && res1 instanceof Error) throw res1
    const res2 = await saveUser('user', res1.data)
    if (res2 && res2 instanceof Error) throw res2
    commit('TOAST_USER', 'Welcome to SpNOD!')
    commit('SIGNEDUP', true)
    return res2
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const updateRoles = async ({ commit, dispatch, state }, data) => {
  try {
    const res = updatePortalUser(data.form, data.id)
    if (res && res instanceof Error) throw res
    dispatch('getMe')
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const createNewClient = async ({ commit, dispatch, getters }, data) => {
  const myInfo = getters.getMyInfo
  const currentData = getters.newUser
  const isTheirParent = getters.isParent
  const body = { currentUser: { _id: myInfo._id, email: myInfo.email, isTheirParent: data.isTheirParent }, newUsers: [data.form], group: data.group }
  try {
    if (currentData && currentData.data.email === data.form.email && isTheirParent === data.isTheirParent) {
      // Don't send request if email or isParent hasn't changed
      return
    } if (currentData && currentData.data.email === data.form.email && isTheirParent !== data.isTheirParent) {
      // Add or Remove the logged in User as a parent if checkbox changes
      const res = await updateClient(currentData._id, body)
      if (res && res instanceof Error) throw res
      commit('SET_NEW_USER', { user: { id: res.data.id, data: data.form }, isTheirParent: data.isTheirParent })
      commit('TOAST_USER', 'User updated!')
      return res
    } else {
      const res = await createClient(body)
      if (res && res instanceof Error) throw res
      commit('SET_NEW_USER', { user: { id: res.data.id, data: data.form }, isTheirParent: data.isTheirParent })
      commit('TOAST_USER', 'User created!')
      return res
    }
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const addUserParents = async ({ commit, dispatch, getters }, data) => {
  const userId = getters.newUser.id
  const myId = getters.getMyInfo._id
  try {
    const res = await putUserParents(myId, { user: userId, parents: data })
    if (res && res instanceof Error) throw res
    commit('SET_PARENTS', data)
    commit('TOAST_USER', 'User updated!')
    return res
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const assignClient = async ({ commit, dispatch, getters }, data) => {
  const dietitian = getters.currentDietitian
  try {
    const body = { nutritionist: dietitian, user: data }
    const res = await postAssignClient(body)
    if (res && res instanceof Error) throw res
    await dispatch('getClients', dietitian)
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const setNewUser = async ({ commit }, data) => {
  commit('SET_NEW_USER', { user: { id: data._id, data } })
}

// ---- Mutation Calls ----
export const resetUsers = async ({ commit, dispatch }) => {
  commit('RESET_USERS')
}

export const resetNewUser = ({ commit, dispatch }) => {
  commit('RESET_NEW_USER')
  commit('RESET_PARENTS')
}

export const deleteUser = ({ commit, dispatch }, data) => {
  commit('DELETE_USER', data)
}

export const updateUser = ({ commit, dispath }, data) => {
  commit('UPDATE_USER', data)
}

export const setUsersPage = ({ commit, dispatch }, data) => {
  commit('SET_USERS_PAGE', data)
}

export const resetRegistrationState = ({ commit, dispatch }, data) => {
  commit('LOGOUT', true) // resets loggedIn, token, and myInfo
  commit('SIGNUPERROR') // resets signedUp, and verified
}



// WEBPACK FOOTER //
// ./src/app/store/users/actions.js